import { createServiceFactory } from '@/services/factory'
import { createMockCustomerService } from './customers.mock'
import { createHttpCustomerService } from './customers.http'

export type { CustomerService } from './customers.service'

export const getCustomerService = createServiceFactory(
  'customers',
  createMockCustomerService,
  createHttpCustomerService
)
